import { GridColumnVisibilityModel, GridColumns, GridRenderCellParams, GridRowParams } from "@mui/x-data-grid";
import { IAirSeaBooking } from "app/types/dataInterfaces";
import { PopoverCell } from "../PopoverCell";
import React from "react";
import { getContainerData } from "app/helpers/containerHelper";
import { processDate } from "app/util/dateUtils";
import { favouriteBooking } from 'app/components/Booking/favouriteBooking';
import { CargoMode } from "app/types/enums";

export const airSeaBookingVisibilityKey = 'AIRSEA_BOOKING_GRID_VISIBILITY';

export const airSeaBookingVisibilityModel: GridColumnVisibilityModel =  {
    shipmentRef: true,
    purchaseOrderNumber: false,
    shipper: true,
    consignee: true,
    portOfLoading: false,
    portOfDischarge: false,
    deliveryAddress: true,
    estimatedDepartureDate: true,
    estimatedArrivalDate: true,
    europaPredictedArrivalDate: true,
    containers: true,
    termType: true,
    associatedQuoteRef: false,
    voyageNumber: true,
    carrier: true
}

export const airSeaBookingColumns: GridColumns<IAirSeaBooking> = [
    {
        field: 'isFavourite',
        headerName: '',
        type: 'boolean',
        minWidth: 50,
        flex: 1,
        renderCell: (params) => {
            return favouriteBooking(params.row);
        }
    },
    {
        field: 'shipmentRef',
        headerName: 'Europa Reference',
        minWidth: 150,
        flex: 1
    },
    {
        field: 'purchaseOrderReferenceNo',
        headerName: 'Purchase Order No',
        minWidth: 150,
        flex: 1
    },
    {
        field: 'shipper',
        headerName: 'Shipper',
        minWidth: 200,
        flex: 1,
    },
    {
        field: 'consignee',
        headerName: 'Consignee',
        minWidth: 200,
        flex: 1,
    },
    {
        field: 'deliveryAddress',
        headerName: 'Delivery Address',
        minWidth: 200,
        flex: 1,
    },
    {
        field: 'portOfLoading',
        headerName: 'Port of Loading',
        minWidth: 100,
        flex: 1,
    },
    {
        field: 'estimatedDepartureDate',
        headerName: 'ETD',
        minWidth: 100,
        flex: 1,
        renderCell: (params: GridRenderCellParams) => {
            return processDate(params.row.estimatedDepartureDate);
        }
    },
    {
        field: 'portOfDischarge',
        headerName: 'Port of Discharge',
        minWidth: 120,
        flex: 1,
    },
    {
        field: 'estimatedArrivalDate',
        headerName: 'ETA',
        minWidth: 100,
        flex: 1,
        renderCell: (params: GridRenderCellParams) => {
            return processDate(params.row.estimatedArrivalDate);
        }
    },
    {
        field: 'europaPredictedArrivalDate',
        headerName: 'Europa Predicted Arrival Date',
        minWidth: 100,
        flex: 1,
        renderCell: (params: GridRenderCellParams) => {
            return processDate(params.row.europaPredictedArrivalDate);
        }
    },
    {
        field: 'containers',
        headerName: 'Container(s)',
        minWidth: 100,
        flex: 1,
        renderCell: (params: GridRenderCellParams) => {
            const data: string[] = params.row['shipmentPackages'].map(sp => getContainerData(params.row, sp));
            return <PopoverCell data={data} />
        }
    },
    {
        field: 'voyageNumber',
        headerName: 'Voyage Number',
        minWidth: 120,
        flex: 1
    },
    {
        field: 'carrier',
        headerName: 'Carrier',
        minWidth: 120,
        flex: 1,
        renderCell: (params: GridRenderCellParams) => {
            return params.row.cargoMode === CargoMode.LCL ? params.row.vesselCarrier : params.row.carrier
        }
    },
    {
        field: 'associatedQuoteRef',
        headerName: 'Associated Quote Ref',
        minWidth: 100,
        flex: 1
    },
    {
        field: 'termType',
        headerName: 'Term Type',
        minWidth: 100,
        flex: 1,
    }];